let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3w7tM")).then(() => parcelRequire('eHc1t'));